import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../pages/Homepage.css";
import Navbar from "../pages/Navbar";
import Footer from "../pages/Footer";
import aboutlap from "./Homepage/Images/aboutlap.svg";


const TermsandConditions = () => {
  return (
    <div>
      <Navbar />
      <div className="about-banner">
        <h2>Terms and Conditions</h2>
        <p>
          By accessing or using our website and services, you agree to comply with and be bound by the following Terms and Conditions. These terms govern your use of our platform, including your rights, obligations, and limitations. We may update these terms from time to time, and your continued use of our services constitutes acceptance of any changes. Please review this page periodically to stay informed about our terms. If you do not agree with any part of these Terms and Conditions, please discontinue use of our services immediately.
        </p>
      </div>
     
      <div className="about-white-line">
        <div className="about-des container pt-5">
            <h3>Key Terms and Conditions</h3>
            <p>
              Please review the following important points regarding your use of our website and services:
            </p>
            <ul>
              <li>You must use our services in compliance with all applicable laws and regulations.</li>
              <li>Unauthorized use or access to our platform is strictly prohibited.</li>
              <li>We reserve the right to modify or discontinue any part of our services at any time.</li>
              <li>Your continued use of our services constitutes acceptance of any changes to these terms.</li>
              <li>All intellectual property on this site belongs to us or our licensors and may not be used without permission.</li>
              <li>We are not liable for any damages resulting from your use or inability to use our services.</li>
            </ul>
        </div>
        <div className="about-location py-5">
            <div className="about-des-location container mx-auto">
            <h3>Our Location</h3>
            <p>Shop No. 203 II Floor, Hiltan Arcade Shopping Center, Evershine CityGokhivare,  Vasai East, Vasai, Mumbai - 401208.</p>
            </div>
            
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsandConditions;
